module.exports = __webpack_public_path__ + "images/emoji/octopus.97adb3eff6673d37ffa2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/octopus.png
// module id = kfDb
// module chunks = 14